<template>
  <div
    id="adaptation-plan"
    class="adaptation-plan"
    data-sidebar="9"
    data-position="0"
    data-name="适配计划"
    v-animate:threshold="0.1"
  >
    <template v-if="!darkMode">
      <PlusImage v-if="isPC" class="logo" :src="ADAPTATION_PLAN.logo" alt="" />
      <PlusImage :key="ADAPTATION_PLAN.logoPad" v-else-if="isPad" class="logo" :src="ADAPTATION_PLAN.logoPad" alt="" />
      <PlusImage :key="ADAPTATION_PLAN.logoH5" v-else class="logo" :src="ADAPTATION_PLAN.logoH5" alt="" />
    </template>
    <template v-else>
      <PlusImage v-if="isPC" class="logo" :src="ADAPTATION_PLAN.logo" alt="" />
      <PlusImage :key="ADAPTATION_PLAN.logoPadDark" v-else-if="isPad" class="logo" :src="ADAPTATION_PLAN.logoPadDark" alt="" />
      <PlusImage :key="ADAPTATION_PLAN.logoH5Dark" v-else class="logo" :src="ADAPTATION_PLAN.logoH5Dark" alt="" />
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MoreCard from "@/components/MoreCard";
import { FIRST_SCREEN, ADAPTATION_PLAN } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
export default {
  name: "AdaptationPlan",
  components: {
    MoreCard,
  },
  computed: {
    ...mapGetters(["isMobile", "isPad", "isPC"]),
  },
  data() {
    return {
      FIRST_SCREEN,
      ADAPTATION_PLAN,
      darkMode: false,
      adaptationList: [
        {
          time: "2025年11月",
          vivo: [
            "X Fold5",
            "X200 Ultra",
            "X200 Pro 卫星通信版",
            "X200 Pro",
            "X200 Pro mini",
            "X200s",
            "X200",
          ],
          iQOO: ["iQOO 13", "iQOO Neo10 Pro+", "iQOO Neo10 Pro", "iQOO Neo10"],
        },
        {
          time: "2025年12月",
          vivo: [
            "X Fold3 Pro",
            "X Fold3",
            "X100 Ultra",
            "X100s Pro",
            "X100 Pro",
            "X100s",
            "X100",
          ],
          iQOO: [
            "iQOO 12 Pro",
            "iQOO 12",
            "iQOO Neo9S Pro+",
            "iQOO Neo9S Pro",
            "iQOO Neo9 Pro",
            "iQOO Neo9",
            "iQOO Z10 Turbo+",
          ],
        },
        {
          time: "2026年1月",
          vivo: [
            "X Fold2",
            "X90 Pro+",
            "X90 Pro",
            "X90s",
            "X90",
            "S30 Pro mini",
            "S30",
          ],
          iQOO: [
            "iQOO 11 Pro",
            "iQOO 11S",
            "iQOO 11",
            "iQOO Z10 Turbo Pro",
            "iQOO Z10 Turbo",
          ],
        },
        {
          time: "2026年2月",
          vivo: ["X Flip", "S20 Pro", "S20"],
          iQOO: [
            "iQOO Neo8 Pro",
            "iQOO Neo8",
            "iQOO Z9 Turbo+",
            "iQOO Z9 Turbo长续航版",
            "iQOO Z9 Turbo",
            "iQOO Z9",
          ],
        },
        {
          time: "2026年3月",
          vivo: [
            "X Fold+",
            "S19 Pro",
            "S19",
            "vivo Pad5 Pro",
            "vivo Pad5",
            "vivo Pad5e",
            "vivo Pad3 Pro",
            "vivo Pad3",
          ],
          iQOO: [
            "iQOO 10 Pro",
            "iQOO 10",
            "iQOO Pad5 Pro",
            "iQOO Pad5",
            "iQOO Pad5e",
            "iQOO Pad2 Pro",
          ],
        },
        {
          time: "2026年4月",
          vivo: ["S18 Pro", "S18", "S18e", "Y500"],
          iQOO: ["iQOO Neo7 竞速版", "iQOO Neo7", "iQOO Neo7 SE"],
        },
        {
          time: "2026年5月",
          vivo: ["Y300GT", "Y300 Pro+", "Y300", "Y300c", "Y300t", "Y300+"],
        },
      ],
    };
  },
  methods: {
    formatNumber(index) {
      const zhMap = {
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
        10: "十",
      };
      return zhMap[index];
    },
    darkModeAdpt() {
      const that = this;
      function updateImageForColorScheme(e) {
        const isDark = e.matches;
        that.darkMode = isDark;
      }
      const darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
      updateImageForColorScheme(darkModeQuery);
      darkModeQuery.addEventListener("change", (e) => {
        this.darkMode = e.matches
        updateImageForColorScheme(e);
      }); 
    },
  },
  mounted() {
    // 曝光埋点
    this.$nextTick(() => {
      initExposureTrack(".adaptation-plan")();
    });
    this.darkModeAdpt();
  },
};
</script>

<style lang="scss" scoped>
.adaptation-plan {
  overflow: hidden;
  background: #fff;
  font-size: 0;
  position: relative;
  padding: 160 * $px1920vw + vw 0;
  text-align: center;
  .logo {
    width: 1200 * $px1920vw + vw;
  }
}

.isPad {
  .adaptation-plan {
    padding: 0;
    .logo {
      width: 100%;
    }
  }
}

.isMobile {
  .adaptation-plan {
    padding: 87 * $px360vw + vw  0 0;
    .logo {
      width: 320 * $px360vw + vw;
    }
  }
}
@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .adaptation-plan {
      padding: 0;
      background: #000;
      .logo {
        width: 100%;
      }
    }
  }
}
</style>